import React, { useEffect, useRef, useState } from 'react';
import styles from './index.modules.less';

export default function MarqueeText({ text, space = 60, speed = 80, ...others }) {
  // 是否需要滚动，文字宽度超出容器宽度时需要滚动
  const [shouldScroll, setShouldScroll] = useState(true);
  const [duration, setDuration] = useState(10);
  const containerRef = useRef();
  const contentRef = useRef();

  useEffect(() => {
    setShouldScroll(false);
    let containerWidth = containerRef.current.clientWidth;
    let contentWidth = contentRef.current.scrollWidth;
    if (contentWidth > containerWidth) {
      setShouldScroll(true);
      setDuration((contentWidth + space) / speed);
    } else {
      setShouldScroll(false);
    }
  }, [text]);

  return (
    <div className={styles.container} ref={containerRef} {...others}>
      <div
        className={styles.content}
        style={{ visibility: shouldScroll ? 'hidden' : 'visible' }}
        ref={contentRef}>
        {text}
      </div>
      {shouldScroll ? (
        <div className={styles.scrollContent} style={{ '--marquee-duration': `${duration}s` }}>
          <span style={{ marginRight: space }}>{text}</span>
          <span style={{ marginRight: space }}>{text}</span>
        </div>
      ) : null}
    </div>
  );
}



// WEBPACK FOOTER //
// ./src/components/MarqueeText/index.js